<div style="display:flex; flex-direction:row">
    <div [ngStyle]="style">
        <gridster [options]="options" class="mat-drawer-container bg-white gridster" style="background-color: white;">
            <gridster-item [item]="item.config" *ngFor="let item of grid.items;let i=index" class="single-row no-shadow" [tabindex]="i">
                <div class="no-padding">
                    <ndc-dynamic [ndcDynamicComponent]="item.widget" [ndcDynamicInputs]="item.metadata"></ndc-dynamic>
                </div>
            </gridster-item>
        </gridster>
    </div>
</div>